import { css } from 'styled-components';
import { themeGet } from '../../../theme/custom-theme';
import { handleTextPlatformSize } from '../text';
import { TextSize } from '../text/types';
import { FontWeight, LinkIndicator } from './types';

export const commonLinkStyles = css<{ fontSize?: TextSize }>`
  color: unset;
  text-decoration: none;
  font-size: ${props => props.fontSize && handleTextPlatformSize};
  &:hover {
    color: ${themeGet('colors.text.blue')};
  }
`;

export const linkWithoutIconStyles = css<{ indicator: LinkIndicator; fontWeight?: FontWeight }>`
  text-decoration-color: ${themeGet('colors.fg.subtle')};
  text-underline-offset: 2px;
  text-decoration: ${props => props.indicator === 'underline' && 'underline'};
  color: ${props => props.indicator === 'color' && themeGet('colors.text.blue')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'inherit')};
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${themeGet('colors.text.blue')};
  }
`;

export const linkWithIconStyles = css<{ fontWeight?: FontWeight; fontSize?: TextSize }>`
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'inherit')};
  svg {
    height: ${props => props.fontSize && handleTextPlatformSize};
    width: ${props => props.fontSize && handleTextPlatformSize};
  }
  &:hover {
    text-decoration: none;
    * {
      color: ${themeGet('colors.text.blue')};
    }
  }
`;

export const iconWrapStyles = {
  display: 'inline-flex',
  gap: 1,
  alignItems: 'center',
  pointerEvents: 'none',
};

export const linkButtonLikeStyles = css`
  text-decoration: none;
`;
